<template>
  <Modal :style="computedWindowSize"
         :visible="visible"
         class="p-fluid"
         @close="close">
    <template v-slot:header>
<!--      <div class="p-dialog-title" v-if="servicesCategoryModal">Change services category</div>-->
<!--      <div class="p-dialog-title" v-if="warehouseItemsCategoryModal">Change warehouse items category</div>-->
      <div class="p-dialog-title">{{ $t('changeCategoryLabel') }}</div>
    </template>
    <Spinner v-if="dataIsSending" :overlayStyle="'height: 80px'"/>
    <div v-else class="p-formgrid p-grid p-pt-3">
      <div class="p-field p-col-12 p-sm-12 p-md-12 p-lg-12">
        <div class="p-float-label">
          <CustomDropdown id="change-item-category-modal"
                          data-key="id"
                          :class="{'p-invalid' : submitted && !selectedCategory}"
                          :filterPlaceholder="$t('findCategoryPlaceholder')"
                          v-model="selectedCategory"
                          :clearSearchData="!visible"
                          :options="categories"
                          optionLabel="name"
                          :filter="true"
                          :showClear="true">
            <template #value="slotProps">
              <div v-if="slotProps.value">
                <span>{{ slotProps.value.name }}</span>
              </div>
              <span v-else style="visibility: hidden">.</span>
            </template>
            <template #option="slotProps">
              <div>
                <span>{{ slotProps.option.name }}</span>
              </div>
            </template>
          </CustomDropdown>
          <label for="change-item-category-modal">{{ $t('Category') }}<span class="warning-color">*</span></label>
        </div>
        <small class="p-invalid" v-if="submitted && !selectedCategory">{{ $t('Required field') }}</small>
      </div>
    </div>
    <template #footer>
      <Button :label="$t('Cancel')" icon="pi pi-times" class="p-button-text" @click="close"/>
      <Button :label="$t('Save')"
              :disabled="disableSaveButton"
              icon="pi pi-check"
              class="p-button-text"
              @click="changeItemsCategory"/>
    </template>
  </Modal>
</template>

<script>
import httpClient from '@/services/http.services'
import settings from "@/settings";
import showErrorsMixins from "@/mixins/showErrorsMixins";

export default {
  mixins: [ showErrorsMixins ],
  emits: ['close', 'change-items-category'],
  name: 'ChangeCategoryModal',
  props: {
    warehouseItemsCategoryModal: {
      type: Boolean,
      default: false,
    },
    servicesCategoryModal: {
      type: Boolean,
      default: false,
    },
    categories: {
      type: Array,
      default: () => [],
    },
    selectedItems: {
      type: Array,
      default: () => [],
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dataIsSending: false,
      disableSaveButton: false,
      selectedCategory: null,
      submitted: false,
    }
  },
  watch: {
    visible() {
      if (!this.visible) {
        this.disableSaveButton = false
        this.dataIsSending = false
        this.submitted = false
        this.selectedCategory = null
      }
    },
  },
  methods: {
    async changeItemsCategory() {
      if (!this.warehouseItemsCategoryModal && !this.servicesCategoryModal) return
      if (!this.selectedItems?.length) return false

      this.submitted = true

      if (!this.selectedCategory) {
        return false
      }

      this.disableSaveButton = true
      this.dataIsSending = true
      
      try {
        const obj = {
          ids: this.selectedItems,
          category_id: this.selectedCategory.id ?? null
        }

        let link = null
        if (this.warehouseItemsCategoryModal) {
          link = 'warehouse/change-items-category'
        } else if (this.servicesCategoryModal) {
          link = 'service/change-items-category'
        }

        if (!link) return
        const { status, data } = await httpClient.post(link, obj)
        if (status === 200 && data?.success) {
          this.$toast.add({severity:'success', detail: this.$t('Data updated'), life: settings.toastLife});
          this.$emit('change-items-category')
        } else if (data?.error) {
          this.$toast.add({severity:'error', summary: data.error.summary, detail: data.error.detail, life: settings.toastLife});
        } else {
          this.showUnknownError()
        }
      } catch(err) {
        this.showError(err)
      } finally {
        this.dataIsSending = false
        this.disableSaveButton = false
      }
    },
    close() {
      this.$emit('close')
      this.submitted = false
    },
  },
  computed: {
    computedWindowSize() {
      if (this.$store.state.mobileLayout) {
        return {width: '95%'}
      } else if (!this.$store.state.mobileLayout && this.$store.state.tabletLayout) {
        return {width: '420px'}
      } else {
        return {width: '420px'}
      }
    },
  },

}
</script>